import React, {useEffect, useRef, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {
  ActivityIndicator,
  Platform,
  StyleSheet,
  TouchableOpacity,
  View,
} from 'react-native';
import {useDispatch, useSelector} from 'react-redux';
import {showSheet} from 'src/actions/SheetActions';
import {isWeb} from 'src/constants';
import {useHistory, useLocation} from 'src/imports/Router';
import {selectrootsheettype} from 'src/selectors/SheetSelector';
import {CustomText} from '../../../../components';
import CustomBottomSheet from '../../../../components/bottom-sheet';
import Button from '../../../../components/button/Button.componet';
import EmptyBox from '../../../../components/empty-box/EmptyBox.component';
import {VehicleDetail} from './VehicleDetail';
import {checkPermitionAndGetPosition} from '../../../../utils/location';
import {useMutation} from 'react-query';
import {selecetvehivletype} from '../../../../selectors/Vehicle';
import {getModal} from '../../../../actions/modal';
import {getVehicle} from '../../../../actions/vehicle';
import {getVehicleslist} from '../../../../actions/vehicleslist';
import useVehiclesList from '../../../../utils/VehiclesList';
import {useApi} from '../../../../providers/ApiProvider';
import {selecetmaptype} from '../../../../selectors/Map';
import PrimaryButton from '../../../../components/primary-button/PrimaryButton.component';
import {selecetusertype} from '../../../../selectors/User';
import {getMap} from '../../../../actions/map';
import {showAlert} from '../../../../actions/AlertActions';
import {
  AnalyticsEvent,
  AnalyticsUserProperties,
} from '../../../../services/analytics/FirebaseAnalytics';
import useCameraPermission from '../../../../hooks/useCameraPermission';
import {selectconfigtype} from '../../../../selectors/config';
import {useDisplayErrorToast} from 'src/utils/displayErrorToast';
import Sentry from 'src/imports/sentry';
import {getApp} from '../../../../actions/app';
import {getUser} from '../../../../actions/user';

export const ConfirmStartTripSheet = ({}) => {
  const {sheetId, sheetProps} = useSelector(state =>
    selectrootsheettype(state),
  );
  const {vehicle, reserveId} = useSelector(state => selecetvehivletype(state));
  const {notshow} = useSelector(state => selecetusertype(state));
  const {userPosition} = useSelector(state => selecetmaptype(state));
  const {api} = useApi();
  const bottomSheetRef = useRef(null);
  const history = useHistory();
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();
  const cameraPermission = useCameraPermission();
  const {reloadVehicleList} = useVehiclesList();
  const [startLoading, setStartLoading] = useState(false);
  const {displayErrorToast} = useDisplayErrorToast();
  const {min_ride_Bicycle, min_ride_Bike} = useSelector(state =>
    selectconfigtype(state),
  );
  const isWarMode = useSelector(state => state.config.is_war_mode);
  let minmon = vehicle.type == 'bike' ? min_ride_Bike : min_ride_Bicycle;

  const closeBottomSheet = () => {
    if (isWeb) {
      bottomSheetRef?.current?.snapTo(() => 0);
    } else {
      bottomSheetRef.current?.close();
      setTimeout(() => {
        dispatch(
          showSheet({
            sheetId: '',
          }),
        );
      }, 500);
    }
  };

  function openHandler() {
    if (isWeb) return;
    bottomSheetRef.current?.expand();
  }

  useEffect(() => {
    switch (sheetId) {
      case 'confirmStartTrip':
        openHandler();
        break;
      default:
        closeBottomSheet();
        break;
    }
  }, [sheetId]);

  const reserveCancelMutation = useMutation({
    mutationFn: async body => {
      return api.reserveCancel(body);
    },
    onSuccess: () => {
      dispatch(
        getMap({
          firstMapViewPort: true,
        }),
      );
      dispatch(
        showSheet({
          sheetId: '',
        }),
      );
      history.push('/main/map');
      dispatch(getVehicle({vehicle: null, reservetime: null, reserveId: null}));
      dispatch(
        getVehicleslist({
          liveActiveVehicle: null,
        }),
      );
      reloadVehicleList();
    },
    onError: err => {
      if (err?.response?.data?.Result == 'Error_NotFound') {
        dispatch(
          showSheet({
            sheetId: '',
          }),
        );
        dispatch(
          getMap({
            firstMapViewPort: true,
          }),
        );
        history.goBack();
      }
      console.log('err12', err.response);
    },
  });
  const dashboardMyTripsMutation = useMutation({
    mutationFn: () => {
      return api.myActiveTrip();
    },
    onSuccess: response => {
      console.log(data?.ActiveTrip, 'data?.ActiveTrip');
      let data = response?.Data;
      if (data?.ActiveTrip) {
        dispatch(
          getVehicle({
            activeSeconds: data?.ActiveTrip?.ActiveSeconds,
            pauseSeconds: data?.ActiveTrip?.PauseSeconds,
            stop: data?.ActiveTrip?.LastDetailStatus == 'pause' ? true : false,
            activeMinutes: Math.round(data?.ActiveTrip?.ActiveSeconds / 60),
            pauseMinutes: Math.round(data?.ActiveTrip?.PauseSeconds / 60),
            money: data?.ActiveTrip?.Price,
          }),
        );
      }
    },
  });
  //trip start
  const tripsStartMutation = useMutation({
    mutationFn: async body => {
      return api.tripsStart(body);
    },
    onSuccess: response => {
      try {
        dispatch(getUser({needUploadImage: true}));
        dispatch(getApp({isFirstTry: true}));
        setStartLoading(false);
        let {id} = response?.Data;
        dispatch(
          getVehicleslist({
            type: 'parking',
          }),
        );
        dispatch(
          getVehicle({
            tripId: id,
            money: minmon * vehicle?.discounted_price,
            debtTripVehicleType: vehicle?.type,
            reserveId: null,
            reservetime: null,
            stop: false,
            activeSeconds: 0,
            pauseSeconds: 0,
            activeMinutes: 0,
            pauseMinutes: 0,
          }),
        );
        // if (notshow) {
        //   history.replace('/main/map/drive');
        // } else {
        //   history.replace('/trip-learn')
        // }
        dispatch(
          showSheet({
            sheetId: '',
          }),
        );
        history.replace('/main/map/drive');

        dispatch(
          showAlert({
            id: 'AlertBox',
            modalProps: {
              icon: 'greenTick',
              title:
                vehicle?.type == 'Bike'
                  ? t('motor_start_success')
                  : t('bike_start_success'),
            },
          }),
        );
        AnalyticsEvent({
          type: 'trip',
          params: {
            trip_action: 'start_trip',
            trip_vehicle_type:
              vehicle?.type === 'Bicycle'
                ? 'bicycle'
                : vehicle?.type === 'Bike'
                ? 'motor'
                : vehicle?.type === 'Scooter'
                ? 'scooter'
                : '',
            trip_id: id,
          },
        });
        AnalyticsEvent({type: 'StartTrip'});
        AnalyticsUserProperties({
          user_trip_vehicle:
            vehicle?.type === 'Bicycle'
              ? 'bicycle'
              : vehicle?.type === 'Bike'
              ? 'moped'
              : vehicle?.type === 'Scooter'
              ? 'scooter'
              : '',
        });
      } catch (err) {
        console.log('err12', err);
      }
    },
    onError: error => {
      try {
        setStartLoading(false);

        let error_type = error?.response?.data?.Result;
        const status = error?.response?.status;
        const errorMesage =
          error?.message === 'Network Error' ? 'Network Error' : error_type;
        Sentry.setTag('api_error', 'start_trip');
        Sentry.captureMessage(
          `tripsStartMutation :Error starting trip :src/pages/damage/damage-list/components/ConfirmStartTripSheet==>error ${errorMesage} - ${status}`,
        );
        if (error_type === 'Error_active_reserve_not_found') {
          dispatch(
            showSheet({
              sheetId: 'tripMessage',
              sheetProps: {
                type: 'reservation_has_ended',
              },
            }),
          );
          dispatch(
            showSheet({
              sheetId: '',
            }),
          );
          history.replace('/main/map');
          dispatch(
            getVehicle({vehicle: null, reservetime: null, reserveId: null}),
          );
          dispatch(
            getVehicleslist({
              liveActiveVehicle: null,
              marker: null,
            }),
          );
          reloadVehicleList();
        } else if (error_type === 'Error_Distance_not_valid') {
          dispatch(showSheet({sheetId: ''}));
          if (Platform.OS === 'android') {
            cameraPermission().then(() => {
              history.push('/scanner');
            });
          } else {
            history.push('/scanner');
          }
        } else if (
          (error_type === 'Error_TryAgain' || error_type === 'TryAgain') &&
          vehicle?.type === 'Bicycle'
        ) {
          dispatch(
            showSheet({
              sheetId: 'tripMessage',
              sheetProps: {
                type: 'lock_stuck',
              },
            }),
          );
        }
        // Handle specific trip start errors
        else if (error_type === 'Error_DuplicateTripRequestDetected') {
          // Toast - خطای ساده
          displayErrorToast(
            error_type,
            [
              {
                key: 'Error_DuplicateTripRequestDetected',
                faMessage: t('Error_DuplicateTripRequestDetected'),
                faTitle: t('duplicate_request'),
              },
            ],
            {
              faMessage: t('Error_DuplicateTripRequestDetected'),
              faTitle: t('duplicate_request'),
            },
          );
          dashboardMyTripsMutation.mutate();
        } else if (error_type === 'Error_TripAlreadyStarted') {
          // Sheet - پیام مهم
          dispatch(
            showSheet({
              sheetId: 'tripMessage',
              sheetProps: {
                type: 'Error_TripAlreadyStarted',
              },
            }),
          );
          dashboardMyTripsMutation.mutate();
        } else {
          displayErrorToast(
            error_type,
            [
              {
                key: 'Error_UnknownError',
                faMessage: t('an_unknown_error_occurred'),
                faTitle: t('connection_error'),
              },
            ],
            {
              faMessage: t('an_unknown_error_occurred'),
              faTitle: t('connection_error'),
            },
          );
        }
      } catch (err) {
        console.log('err12', err);
      }
    },
  });

  const startTrip = () => {
    try {
      setStartLoading(true);
      if (isWarMode === true) {
        if (Platform.OS === 'android') {
          cameraPermission().then(() => {
            history.push('/scanner');
          });
        } else {
          history.push('/scanner');
        }
        setStartLoading(false);
        dispatch(showSheet({sheetId: ''}));
        return;
      }
      checkPermitionAndGetPosition({
        onSuccess: position => {
          let mutationBody = {
            ReserveId: reserveId,
            Latitude: position.coords?.latitude,
            Longitude: position.coords?.longitude,
          };
          console.log('mutationBody11', mutationBody);
          tripsStartMutation.mutate(mutationBody);
        },
        onError: err => {
          if (err.code !== 1) {
            let mutationBody = {
              ReserveId: reserveId,
              Latitude: userPosition?.lat ?? 0,
              Longitude: userPosition?.lng ?? 0,
            };
            tripsStartMutation.mutate(mutationBody);
          } else {
            history.replace('/main/map/reserved');
          }
        },
      });
    } catch (err) {
      console.log('err12', err);
    }
  };

  const cancleReservePress = () => {
    dispatch(getModal({func: null, modal: false}));
    reserveCancelMutation.mutate({
      reserve_id: reserveId,
    });
  };

  return (
    <>
      <CustomBottomSheet
        onClose={closeBottomSheet}
        ref={bottomSheetRef}
        enablePanDownToClose={isWeb ? undefined : false}
        expandOnContentDrag={isWeb ? false : undefined}
        snapPoints={isWeb ? ({minHeight}) => [1, minHeight] : [321]}
        onSpringEnd={
          isWeb
            ? () => {
                if (bottomSheetRef?.current?.height < 2) {
                  history.push('/main/map');
                  dispatch(showSheet({sheetId: ''}));
                }
              }
            : undefined
        }
        defaultSnap={isWeb ? 301 : undefined}
        open={sheetId !== ''}
        scrollViewStyle={isWeb ? undefined : styles.scroll}
        blocking={isWeb ? true : undefined}
        scrollLocking={isWeb ? false : undefined}>
        <View style={styles.container}>
          <View>
            <EmptyBox height={12} />
            <CustomText color={'#09CF02'} size={12} font={'400'}>
              {t('thank_you_for_your_information')}
            </CustomText>
            <EmptyBox height={16} />
            <CustomText size={15} font={'700'} color={'#2D2D2D'}>
              {t('do_you_want_to_keep_going_with_this_vehicle')}
            </CustomText>
            <EmptyBox height={12} />
            <VehicleDetail hasReadyLabel={false} hasIcon item={vehicle} />
          </View>
          <View>
            <PrimaryButton
              title={t('start_trip_with_this_vehicle')}
              textStyle={{
                fontSize: 16,
              }}
              containerStyle={{
                height: 40,
                paddingBottom: 0,
                paddingTop: 0,
              }}
              onPress={startTrip}
              isLoading={startLoading}
            />
            <TouchableOpacity
              activeOpacity={1}
              style={styles.cancleButton}
              onPress={cancleReservePress}>
              {reserveCancelMutation.isLoading ? (
                <ActivityIndicator size={'small'} color={'#000'} />
              ) : (
                <CustomText
                  txtAlign="center"
                  color={'#F74B4A'}
                  size={12}
                  font={'500'}>
                  {t('revert_to_map_and_reserve_new_vehicle')}
                </CustomText>
              )}
            </TouchableOpacity>
          </View>
        </View>
      </CustomBottomSheet>
    </>
  );
};

const styles = StyleSheet.create({
  cancleButton: {
    paddingTop: 10,
    paddingBottom: 20,
    width: '100%',
    alignItems: 'center',
  },
  container: {
    width: '100%',
    height: 301,
    paddingHorizontal: 16,
    justifyContent: 'space-between',
  },
  buttontext: {
    // fontFamily: styles.font.IranYekan[400],
    fontSize: 18,
  },
});
